import { App } from '@config/site/app'
import { Divider, ExternalPage, Page } from '@config/site/app/pages'

export const DocsMenu: Partial<Record<App, (Page | ExternalPage | typeof Divider | 'supportEmail')[]>> = {
  [App.STAR]: [Page.DATA_HEALTH, Divider, ExternalPage.GITBOOK, Divider, 'supportEmail'],
  [App.MUSIC]: [ExternalPage.GITBOOK],
}
